/**
 * Terms of Service Links
 *
 * Region-specific links for TOS disclaimers and privacy policies.
 * Matches the link structure used in ecto1.
 */

import { CookieConsentRegion } from '@/lib/geo/region';

/**
 * Terms of Service links for blocking dialogs
 */
export const TermsOfServiceLinks = {
  /**
   * AI Terms of Service (default/ROW)
   */
  AI_TERMS: 'https://www.facebook.com/legal/ai-terms',

  /**
   * AI Terms of Service for EU
   */
  AI_TERMS_EU: 'https://www.facebook.com/legal/eu-ai-terms',

  /**
   * AI Terms of Service for UK
   */
  AI_TERMS_UK: 'https://www.facebook.com/legal/uk-ai-terms',

  /**
   * AI Terms of Service for Brazil
   */
  AI_TERMS_BR: 'https://www.facebook.com/legal/br-ai-terms',

  /**
   * Privacy Policy for AI Partners - TOS specific
   */
  PRIVACY_POLICY_AI_PARTNERS: 'https://www.facebook.com/privacy/dialog/ai-partners',

  /**
   * AI at Meta Privacy - user rights and AI privacy info
   */
  AI_AT_META_PRIVACY: 'https://www.facebook.com/privacy/genai/',

  /**
   * Meta Privacy Policy
   */
  PRIVACY_POLICY: 'https://www.facebook.com/privacy/policy',

  /**
   * Cookies Notice — used for all regions
   */
  COOKIES_NOTICE: 'https://www.facebook.com/legal/ai-cookies',

  /**
   * Object to TOS link - for users to object to data usage
   */
  OBJECT_TOS_LINK: 'https://auth.meta.com/form/?form_id=1195697011444585',

  /**
   * Learn more about Privacy Policy for AI
   */
  LEARN_MORE: 'https://www.facebook.com/privacy/guide/genai',
} as const;

/**
 * Get the appropriate AI Terms link for a given region
 */
export function getAITermsLink(region: CookieConsentRegion): string {
  switch (region) {
    case CookieConsentRegion.EU:
      return TermsOfServiceLinks.AI_TERMS_EU;
    case CookieConsentRegion.UK:
      return TermsOfServiceLinks.AI_TERMS_UK;
    case CookieConsentRegion.BR:
      return TermsOfServiceLinks.AI_TERMS_BR;
    case CookieConsentRegion.ROW:
    default:
      return TermsOfServiceLinks.AI_TERMS;
  }
}

/**
 * Get the Cookies link. All regions now use the same AI Cookies page.
 */
export function getCookiesLink(_region?: CookieConsentRegion): string {
  return TermsOfServiceLinks.COOKIES_NOTICE;
}
